import { useState, useCallback } from "react";

export const useCalendarFilters = () => {
  const [selectedStudy, setSelectedStudy] = useState("");
  const [selectedEmail, setSelectedEmail] = useState("");

  const handleStudyChange = useCallback((study: string) => {
    setSelectedStudy(study);
  }, []);

  const handleEmailChange = useCallback((email: string) => {
    setSelectedEmail(email);
  }, []);

  const clearFilters = useCallback(() => {
    setSelectedStudy("");
    setSelectedEmail("");
  }, []);

  return {
    selectedStudy,
    selectedEmail,
    handleStudyChange,
    handleEmailChange,
    clearFilters,
  };
};
